import logger from '@vatom/logger'

const log = logger.extend('sdk:plugins:vatomNew')

export default log
